import React, { useState } from 'react';
import { vEmail, strongRegularExp, isValidZipCode } from '../constants/constants';
import { isIntegerValue, isStringValue } from '../utility-files/data-util/DataHandling';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

function validateContactNumber(number) {
    const digits = number.replace(/\D/g, "");
    return digits.length >= 10 && digits.length <= 15;
}

const inputTextDefaultLength = 100;
const inputTextAreaDefaultLength = 300;

function CustomInput({
    fieldType,
    classType,
    setFieldData,
    filedData,
    fieldId,
    keyName,
    selectList,
    defaultName,
    isReadOnly,
    getSearchResults,
    headerName,
    objKey,
    placeholderType,
    onMouseOver,
    onMouseOut,
    maxCharacterLength,
    textArearows,
    textAreacols,
    country,
    ...rest
}) {
    const handleInputValues = (inputKey, data) => {
        let maxLength, dataHandler;
        maxLength = maxCharacterLength ? data?.length <= isIntegerValue(maxCharacterLength) :
            fieldType === "textarea" ? data?.length <= isIntegerValue(inputTextAreaDefaultLength) :
                data?.length <= inputTextDefaultLength;
        dataHandler = data.replace(/[^\w\s]/gi, "");
        dataHandler = dataHandler.replace("_", "");
        switch (inputKey) {
            case 'color':
                setFieldData(state => ({ ...state, [keyName]: data }));
                break;
            case 'url':
                var regex = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
                if (maxLength) {
                    setFieldData(state => ({ ...state, [keyName]: data, isUrlValid: regex.test(data.toLowerCase()) }));
                }
                break;
            case 'text':
                if (keyName === 'description' && maxLength) {
                    setFieldData(state => ({ ...state, [keyName]: data }));
                } else if (objKey && maxLength) {
                    setFieldData(state => ({ ...state, [objKey]: { ...filedData[objKey], [keyName]: dataHandler } }))
                } else if (keyName === 'confirmPassword' && maxLength) {
                    setFieldData(state => ({ ...state, [keyName]: data, isConfirmPasswordValid: strongRegularExp?.test(data) }));
                } else if (keyName === 'currentPassword' && maxLength) {
                    setFieldData(state => ({ ...state, [keyName]: data, isCurrentPasswordValid: strongRegularExp?.test(data) }));
                } else if (keyName === 'password' && maxLength) {
                    setFieldData(state => ({ ...state, [keyName]: data, isPasswordValid: strongRegularExp?.test(data) }));
                } else if ((keyName === "name" || keyName === "labelName" || keyName?.toLowerCase()?.includes('attribute')) && maxLength) {
                    setFieldData(state => ({ ...state, [keyName]: data }));
                } else if (maxLength) {
                    setFieldData(state => ({ ...state, [keyName]: dataHandler }));
                }
                break;
            case 'textarea':
                if (maxLength) {
                    setFieldData(state => ({ ...state, [keyName]: data }));
                }
                break;
            case 'search':
                if (!headerName) {
                    getSearchResults(data);
                } else {
                    setFieldData(state => ({ ...state, [keyName]: data }));
                }
                break;
            case 'number':
                if (/^[0-9\b]+$/.test(isIntegerValue(parseInt(data))) || data === '') {
                    if (keyName === 'zipCode' && maxLength) {
                        setFieldData(state => ({ ...state, [keyName]: data, isZipCodeValid: isValidZipCode(data) }));
                    } else if (maxLength && parseInt(data[0]) !== 0) {
                        setFieldData(state => ({ ...state, [keyName]: data }));
                    };
                }
                break;

            // case 'phone':
            //     if (data) {
            //         setFieldData(state => ({ ...state, [keyName]: data }));
            //     }
            //     break;
            case 'phone':
                if (data) {
                    const digitsOnly = data.replace(/\D/g, "");
                    const phoneNumber = digitsOnly.slice(-10);
                    const isValid = phoneNumber.length === 10;

                    setFieldData(state => ({
                        ...state,
                        [keyName]: data,
                        countryCode: country?.dialCode,
                        countryIso: country?.countryCode,
                        trimmedContact: phoneNumber,
                        isContactNumberValid: isValid
                    }));
                } else {
                    setFieldData(state => ({
                        ...state,
                        [keyName]: "",
                        countryCode: "",
                        countryIso: "",
                        trimmedContact: "",
                        isContactNumberValid: false
                    }));
                }
                break;






            case 'password':
                if (keyName === 'confirmPassword' && maxLength) {
                    setFieldData(state => ({ ...state, [keyName]: data, isConfirmPasswordValid: strongRegularExp?.test(data) }));
                } else if (keyName === 'currentPassword' && maxLength) {
                    setFieldData(state => ({ ...state, [keyName]: data, isCurrentPasswordValid: strongRegularExp?.test(data) }));
                } if (keyName && maxLength) {
                    setFieldData(state => ({ ...state, [keyName]: data, isPasswordValid: strongRegularExp?.test(data) }));
                }
                break;
            case 'email':
                if (keyName && maxLength) {
                    setFieldData(state => ({ ...state, [keyName]: data, isEmailValid: vEmail?.test(data) }));
                }
                break;
            default:
                if (keyName && maxLength) {
                    setFieldData(state => ({ ...state, [keyName]: data }));
                }
                break;
        };
    };

    const handleContactInputValues = (data, countrycode) => {

        let isValid = false;
        if (data.length > 0 && countrycode.dialCode.length > 0)
            isValid = data.length - countrycode.dialCode.length >= 10
        if (data) {


            setFieldData(state => ({
                ...state,
                [keyName]: data,
                countryCode: countrycode?.dialCode,
                countryIso: countrycode?.countryCode,
                trimmedContact: data,
                isContactNumberValid: isValid
            }));
        } else {
            setFieldData(state => ({
                ...state,
                [keyName]: "",
                countryCode: "",
                countryIso: "",
                trimmedContact: "",
                isContactNumberValid: isValid
            }));
        }
    };

    const inputValues = () => {
        if (fieldType === "email") {
            return <input
                type={isStringValue(fieldType)}
                id={isStringValue(fieldId)}
                value={filedData && keyName ? isStringValue(filedData[keyName]) : isStringValue(defaultName)}
                className={isStringValue(classType)}
                onChange={(event) => handleInputValues(fieldType, event.target.value)}
                readOnly={isReadOnly === 'true' ? true : false}
                placeholder={isStringValue(placeholderType)}
                maxlength={maxCharacterLength || inputTextDefaultLength}
                {...rest}
            />
        };

        if (fieldType === "color") {
            return <input
                type={isStringValue(fieldType)}
                id={isStringValue(fieldId)}
                value={filedData && keyName ? isStringValue(filedData[keyName]) : isStringValue(defaultName)}
                className={isStringValue(classType)}
                onChange={(event) => handleInputValues(fieldType, event.target.value)}
                readOnly={isReadOnly === 'true' ? true : false}
                placeholder={isStringValue(placeholderType)}
                maxlength={maxCharacterLength || inputTextDefaultLength}
                {...rest}
            />
        };

        if (fieldType === "password") {
            return <input
                type={isStringValue(fieldType)}
                id={isStringValue(fieldId)}
                value={filedData && keyName ? filedData[keyName] : isStringValue(defaultName)}
                className={isStringValue(classType)}
                onChange={(event) => handleInputValues(fieldType, event.target.value)}
                placeholder={isStringValue(placeholderType)}
                maxlength={maxCharacterLength || inputTextDefaultLength}
                {...rest}
            />
        };

        if (fieldType === "text" && !objKey) {
            return <input
                type={isStringValue(fieldType)}
                id={isStringValue(fieldId)}
                value={filedData && keyName ? filedData[keyName] : isStringValue(defaultName)}
                className={isStringValue(classType)}
                onChange={(event) => handleInputValues(fieldType, event.target.value)}
                readOnly={isReadOnly === 'true' ? true : false}
                placeholder={isStringValue(placeholderType)}
                maxlength={maxCharacterLength || inputTextDefaultLength}
                {...rest}
            />
        };

        if (fieldType === "url") {
            return <input
                type={isStringValue('text')}
                id={isStringValue(fieldId)}
                value={filedData && keyName ? filedData[keyName] : isStringValue(defaultName)}
                className={isStringValue(classType)}
                onChange={(event) => handleInputValues(fieldType, event.target.value)}
                readOnly={isReadOnly === 'true' ? true : false}
                placeholder={isStringValue(placeholderType)}
                maxlength={maxCharacterLength || inputTextDefaultLength}
                {...rest}
            />
        };

        if (fieldType === "text" && objKey) {
            return <input
                type={isStringValue(fieldType)}
                id={isStringValue(fieldId)}
                value={filedData && keyName ? filedData[objKey][keyName] : isStringValue(defaultName)}
                className={isStringValue(classType)}
                onChange={(event) => handleInputValues(fieldType, event.target.value.replace(/[^\w\s]/gi, ""))}
                readOnly={isReadOnly === 'true' ? true : false}
                placeholder={isStringValue(placeholderType)}
                maxlength={maxCharacterLength || inputTextDefaultLength}
                {...rest}
            />
        };

        if (fieldType === "textarea") {
            return <textarea
                id={isStringValue(fieldId)}
                name={keyName}
                value={filedData && keyName ? filedData[keyName] : isStringValue(defaultName)}
                rows={textArearows || "4"} cols={textAreacols || "73"}
                className={isStringValue(classType)}
                onChange={(event) => handleInputValues(fieldType, event.target.value.replace(/^[\d\(\)\-+_]+$/.test, ""))}
                readOnly={isReadOnly === 'true' ? true : false}
                placeholder={isStringValue(placeholderType)}
                maxlength={maxCharacterLength || inputTextAreaDefaultLength}
                {...rest}
            />
        };

        if (fieldType === "number") {
            var invalidChars = [
                ".",
                "-",
                "+",
                "e",
                "E"
            ];
            return <input
                type="text"
                id={isStringValue(fieldId)}
                min='1'
                value={filedData && keyName && filedData[keyName] !== 0 ? filedData[keyName] : isStringValue(defaultName)}
                className={isStringValue(classType)}
                onChange={(event) => handleInputValues(fieldType, event.target.value.replace(/[^\w\s]/gi, ""))}
                readOnly={isReadOnly === 'true' ? true : false}
                placeholder={isStringValue(placeholderType)}
                onKeyDown={(e) => {
                    if (invalidChars.includes(e.key)) {
                        e.preventDefault();
                    }
                }}
                onInput={(event) => {
                    event.target.value = event.target.value.replace(/[^0-9+]/g, '')
                }}
                maxlength={maxCharacterLength || inputTextDefaultLength}
                {...rest}
            />
        };

        if (fieldType === "phone") {
            return (
                <PhoneInput
                    country={"us"}
                    onlyCountries={["us", "in", "gb", "ca", "de"]}
                    value={filedData && keyName ? filedData[keyName] : ""}
                    // onChange={(phone, country) => handleInputValues(fieldType, phone)}
                    //                     onChange={(value, countryData, e, formattedValue) => {
                    //     console.log("Full value:", value);          // e.g. "14155552671"
                    //     console.log("Country code:", countryData.dialCode); // e.g. "1"
                    //     console.log("ISO code:", countryData.countryCode);  // e.g. "us"
                    //   }}

                    onChange={(phone, value) => handleContactInputValues(phone, value)}
                    inputProps={{
                        id: isStringValue(fieldId),
                        name: keyName,
                        readOnly: isReadOnly === "true" ? true : false,
                        required: rest?.required || false,

                    }}
                    inputStyle={{
                        width: "100%",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        height: "38px",
                    }}
                    specialLabel={""}
                    countryCodeEditable={false}
                    placeholder={isStringValue(placeholderType)}
                />


            );
        }

        if (fieldType === "date") {
            return <input
                type={fieldType}
                id={isStringValue(fieldId)}
                value={filedData && keyName && filedData[keyName] ? filedData[keyName] : ''}
                className={isStringValue(classType)}
                onChange={(event) => handleInputValues(fieldType, event.target.value)}
                {...rest}
            />
        };

        if (fieldType === "select" && selectList?.length !== 0) {
            return <select name={`${keyName}`} className={isStringValue(classType)} id={`${keyName}`} value={filedData && keyName ? filedData[keyName] : ''} onChange={(event) => handleInputValues(fieldType, event.target.value)} {...rest}>
                {selectList?.map((item) => {
                    return <option key={item?.id} value={item?.id}>{item?.name}</option>
                })}
            </select>
        };
    };

    return (<>
        {inputValues()}
        {fieldType === "textarea" && <div id="the-count">
            <span id="current">{filedData?.[objKey]?.[keyName]?.length || filedData?.[keyName]?.length || isStringValue(defaultName).length}</span>
            <span id="maximum">/ {maxCharacterLength || inputTextAreaDefaultLength}</span>
        </div>}
    </>)
}

export default CustomInput